import delay from 'delay'
import ms from 'ms'
// eslint-disable-next-line no-restricted-imports -- TODO: Fix this the next time the file is edited.
import lodash from 'lodash'

const { isEqual } = lodash

// we define configs on feature level.
// we need this default value on feature definition
export const DEFAULT_FETCH_INTERVAL = ms('2m')

class ApyRatesMonitor {
  #logger
  #pricingClient
  #assetsAtom
  #stakingAssetNames
  #fetchInterval
  #apyRatesAtom

  constructor({ pricingClient, assetsAtom, apyRatesAtom, logger, config }) {
    this.#logger = logger
    this.#pricingClient = pricingClient
    this.#assetsAtom = assetsAtom
    this.#apyRatesAtom = apyRatesAtom
    this.#stakingAssetNames = config.stakingAssetNames
    this.#fetchInterval = config.fetchInterval || DEFAULT_FETCH_INTERVAL
  }

  #started = false
  #tickDelay

  #fetch = async () => {
    const stakingRewards = await this.#pricingClient.stakingRewards()

    if (!stakingRewards || stakingRewards.length === 0) return

    const { value } = await this.#assetsAtom.get()
    const assetNamesByTicker = new Map(
      Object.values(value).map((asset) => [asset.ticker, asset.name])
    )

    const rates = stakingRewards.reduce((acc, next) => {
      const assetName = assetNamesByTicker.get(next.asset)

      if (!Number.isFinite(next.reward)) {
        throw new TypeError(`wrong apy rates data ${JSON.stringify(stakingRewards)}`)
      }

      if (assetName) {
        if (!this.#stakingAssetNames || this.#stakingAssetNames.includes(assetName)) {
          acc[assetName] = next.reward
        }
      }

      return acc
    }, Object.create(null))

    this.#apyRatesAtom.set((current) => (isEqual(current, rates) ? current : rates))
  }

  stop() {
    this.#started = false
    this.#tickDelay?.clear()
  }

  async start() {
    if (this.#started) return

    this.#started = true

    while (this.#started) {
      try {
        await this.#fetch()
        if (!this.#started) break
        this.#tickDelay = delay(this.#fetchInterval)
        await this.#tickDelay
      } catch (err) {
        this.#logger.error('failed to fetch apy rates', err)
        if (!this.#started) break
        this.#tickDelay = delay(ms('5s'))
        await this.#tickDelay
      }
    }
  }
}

const createApyRatesMonitor = (args) => new ApyRatesMonitor(args)

// eslint-disable-next-line @exodus/export-default/named
export default {
  id: 'apyRatesMonitor',
  type: 'monitor',
  factory: createApyRatesMonitor,
  dependencies: ['pricingClient', 'assetsAtom', 'apyRatesAtom', 'logger', 'config'],
  public: true,
}
